var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("multiselect", {
    staticClass: "mx-auto",
    attrs: {
      value: _vm.selectedBuilding,
      "open-direction": "bottom",
      label: "label",
      options: _vm.buildings,
      "show-labels": false,
      searchable: false
    },
    on: { input: _vm.redirect }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }